import { css } from '@emotion/css';
import classNames from 'classnames';
import globalStyle from 'constants/global.style';
import { colors } from 'constants/theme';
import { Bank3rdItem, bankQuick, winPayActive } from 'models/bankModel';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { NumericFormat } from 'react-number-format';
import depositPageStyle from './deposit.styles';
import TagLabel from 'components/tag-label/TagLabel';
import { removeFormatMoney } from 'utils/function';
import { tryImg } from 'utils/safeImage';

const listAmountQuick = [
    {
        value: 200000,
        label: '200K',
    },
    {
        value: 500000,
        label: '500K',
    },
    {
        value: 1000000,
        label: '1TR',
    },
    {
        value: 2000000,
        label: '2TR',
    },
    {
        value: 5000000,
        label: '5TR',
    },
    {
        value: 10000000,
        label: '10TR',
    },
    {
        value: 20000000,
        label: '20TR',
    },
    {
        value: 50000000,
        label: '50TR',
    },
    {
        value: 100000000,
        label: '100TR',
    },
    {
        value: 300000000,
        label: '300TR',
    },
];

// const urlBank3rdIcon = process.env.REACT_APP_BASE_API || 'https://api.tin88.xyz';

interface Props {
    activeSubList: boolean;
    bank3rdList: Bank3rdItem[];
    minMaxDeposit: { min: number; max: number };
    onSubmit3rd: (payload: { amount: string; bankName: string; channelNo: string }) => void;
    onSubmitVNPAY: (payload: { amount: string; bankCode: string; channel: string }) => void;
    onWinPaySubActive: bankQuick;
}

function Bank3rdDeposit(props: Props) {
    const { activeSubList, bank3rdList, minMaxDeposit, onWinPaySubActive, onSubmitVNPAY, onSubmit3rd } = props;
    const [bankSelect, setBankSelect] = useState<Bank3rdItem>({} as Bank3rdItem);
    const [amountDeposit, setAmountDeposit] = useState('');

    useEffect(() => {
        setBankSelect({} as Bank3rdItem);
    },[bank3rdList]);

    const selectBank = (bankItem: Bank3rdItem) => {
        setBankSelect(bankItem);
    };

    const submitDeposit = async () => {
        if ((Object.keys(bankSelect).length <= 0) && activeSubList) {
            toast.error('Vui lòng chọn ngân hàng');
            return;
        }
        if (!amountDeposit) {
            toast.error('Vui lòng chọn số tiền muốn nạp');
            return;
        }

        if (Number(amountDeposit) < 200000) {
            toast.error('Số tiền nạp tối thiểu cho phép là 200,000');
            return;
        }
        const payload = {
			amount: removeFormatMoney(amountDeposit),
            bankName: bankSelect.bankName,
            channelNo: bankSelect.channelNo
		};

        const payloadVNPAY = {
            amount: removeFormatMoney(amountDeposit),
            bankCode: bankSelect.bankName,
            channel: bankSelect.channelNo
        }

        const payloadVNPAYBANK = {
            amount: removeFormatMoney(amountDeposit),
            bankCode: bankSelect.actionName,
            channel: bankSelect.channelNo
        }

        if(onWinPaySubActive.channelName === 'VNPAY') {
            onSubmitVNPAY(payloadVNPAY);
        } else {
            if(bankSelect.channelNo === 'bank_transfer' || onWinPaySubActive.channelName === 'V8PAY') {
                onSubmitVNPAY(payloadVNPAYBANK);
            } else {
                onSubmit3rd(payload);
            }
        }
    };

    return (
        <>
            {activeSubList ? (
                <div className={styles.wrap3rd}>
                    {bankSelect.bankName ? (
                        <h6 className={depositPageStyle.titleBankGroup}>
                            2. Bạn đang chọn ngân hàng <span>{bankSelect.bankName}</span>
                        </h6>
                    ) : (
                        <h6 className={depositPageStyle.titleBankGroup}>2 .Chọn ngân hàng thanh toán</h6>
                    )}
                    <div className={depositPageStyle.bankList}>
                        {bank3rdList.map((bank, index) => (
                            <div className={classNames(depositPageStyle.bankItem, { active: bankSelect.bankName === bank.bankName })} key={index} onClick={() => selectBank(bank)}>
                                <div className={depositPageStyle.bankItemInner}>
                                    <img className={`${depositPageStyle.bankIcon}`} src={tryImg(() => require(`assets/images/bank-list/${bank.bankName.toLocaleLowerCase()}.jpg`))} alt={bank.bankName} />
                                    {bankSelect.bankName === bank.bankName && <img className={depositPageStyle.iconBankSelect} src={require('assets/images/icons/tick-bank.png')} alt="" />}
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className={styles.wrap}>
                        <div className={styles.left}>
                            <h6 className={depositPageStyle.titleBankGroup}>3. Chọn số tiền nạp</h6>
                            <div className={styles.amountList}>
                                {listAmountQuick.map((item) => (
                                    <div className={styles.amountItem} key={item.value}>
                                        <p className={styles.amountItemInner} onClick={() => setAmountDeposit(String(item.value))}>
                                            {item.label}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={styles.right}>
                            <h6 className={depositPageStyle.titleBankGroup}>Hoặc nhập số tiền nạp (VNĐ)</h6>
                            <NumericFormat className="input-common" thousandSeparator="," placeholder="Nhập số tiền..." value={amountDeposit} onChange={(e) => setAmountDeposit(e.target.value)} />
                            <TagLabel label={`Tối thiểu ${new Intl.NumberFormat().format(minMaxDeposit.min)} - Tối đa ${new Intl.NumberFormat().format(minMaxDeposit.max)}`} />
                        </div>
                    </div>
                    <div style={{ width: 'calc(60% - 50px)', marginTop: '30px' }}>
                        <button type="button" className={globalStyle.btnPrimary} onClick={submitDeposit}>
                            Gửi Lệnh
                        </button>
                    </div>
                </div>
            ): (
                <>
                    <div className={styles.wrap3rd}>
                    <div className={styles.wrap}>
                        <div className={styles.left}>
                            <h6 className={depositPageStyle.titleBankGroup}>3. Chọn số tiền nạp</h6>
                            <div className={styles.amountList}>
                                {listAmountQuick.map((item) => (
                                    <div className={styles.amountItem} key={item.value}>
                                        <p className={styles.amountItemInner} onClick={() => setAmountDeposit(String(item.value))}>
                                            {item.label}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={styles.right}>
                            <h6 className={depositPageStyle.titleBankGroup}>Hoặc nhập số tiền nạp (VNĐ)</h6>
                            <NumericFormat className="input-common" thousandSeparator="," placeholder="Nhập số tiền..." value={amountDeposit} onChange={(e) => setAmountDeposit(e.target.value)} />
                            <TagLabel label={`Tối thiểu ${new Intl.NumberFormat().format(minMaxDeposit.min)} - Tối đa ${new Intl.NumberFormat().format(minMaxDeposit.max)}`} />
                        </div>
                    </div>
                    <div className={`${styles.elmSubmit}`}>
                        <button type="button" className={`btn-primary ${styles.btnSubmit}`} onClick={submitDeposit}>
                            Tiến hành nạp tiền
                        </button>
                    </div>
                    </div>
                </>
            )}
            
        </>
    );
}

const styles = {
    wrap3rd: css`
        margin-top: 16px;
    `,
    wrap: css`
        /* display: flex;
        align-items: flex-start; */
        gap: 50px;
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid ${colors.borderTable};
    `,
    left: css`
        flex: 0 0 calc(60% - 50px);
    `,
    amountList: css`
        display: flex;
        flex-wrap: wrap;
        background: linear-gradient(to bottom, #B80005, #710003);
        border-radius: 10px;
        padding: 5px;
        margin-bottom: 20px;
    `,
    amountItem: css`
        padding: 4px;
        flex: 0 0 10%;
        max-width: 10%;
    `,
    amountItemInner: css`
        padding: 8px 0;
        border-radius: 8px;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, .4);
        cursor: pointer;
        text-align: center;
        background: rgba(0, 0, 0, .4);
        color: var(--white-color);
        font-weight: 700;
        &:active, &:hover {
            background: linear-gradient(0deg, #002287 0%, rgba(2, 126, 251, 1) 100%);
        }
    `,
    right: css`
        max-width: 40%;
        p {
            color: red;
        }
    `,
    elmSubmit: css`
        max-width: 40%;
        width: 100%;
    `,
    btnSubmit: css`
        padding: 10px 0;
        font-weight: 600;
        border-radius: 8px;
        cursor: pointer;
        margin: 0 auto;
        text-transform: uppercase;
    `,
};

export default Bank3rdDeposit;
